import { create } from 'zustand'

export const useConfigStore = create((set) => ({
  configs: null,
  setConfig: (configs) => set(() => {
    return {configs};
  }),
}))
